"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
function useRenderCellViews() {
    var renderCellViews = (0, react_1.useCallback)(function (cellValue) {
        return [
            {
                key: "event_type",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }),
            },
            {
                key: "display_name",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: cellValue }),
            },
            {
                key: "description",
                content: ((0, jsx_runtime_1.jsx)("div", { className: "text-sm text-default-foreground max-w-xs truncate", children: cellValue || "-" })),
            },
        ];
    }, []);
    return (0, react_1.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
